// extracted by mini-css-extract-plugin
module.exports = {"root":"avatar_root__ZHUp6","clickable":"avatar_clickable__6VRfO","image":"avatar_image__xQkdK","initials":"avatar_initials__CKtcw","shape":"avatar_shape__JGB23"};